import { api } from "../core/api";

export async function getCategories(params?: {
  query?: string;
}): Promise<CategoryDto[]> {
  const entries = Object.entries(params ?? {}).filter((it) => !!it[1]);
  const search = new URLSearchParams(entries);
  const { data } = await api.get(`/api/v1/test_categories?${search}`);
  return data.data;
}

export interface CategoryDto {
  id: string;
  acronym: string;
  name: string;
  scenarios: number;
}
